import { css } from '@emotion/react';

const savedContactsPreviewStyles = {
    container: css({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        gap: '10px',
        alignItems: 'center',
        padding: '10px 0',
        marginBottom: '5px'
    }),
    letfBlock: css({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '10px',
    }),
    userPlaceholder: css({
        width: '40px',
        height: '40px',
    }),
    informationBlock: css({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        gap: '5px',
    }),
    userName: css({
        fontSize: '14px',
        fontWeight: 600,
        color: '#000000',
        margin: 0,
    }),
    userContacts: css({
        fontSize: '12px',
        fontWeight: 300,
        color: '#141416',
        margin: 0,
    }),
    rightBlock: css({
        display: 'flex',
        flexDirection: 'row',
        height: '100%',
        alignItems: 'center',
    }),
};

export default savedContactsPreviewStyles;